const FONTS = {
    drukWide: "Druk Wide",
    helvetica: "Helvetica",
    helveticaNeue: "Helvetica Neue LT Std"
};

export default FONTS;
